import { render, staticRenderFns } from "./Checkin.vue?vue&type=template&id=388752a8&scoped=true&"
import script from "./Checkin.vue?vue&type=script&lang=js&"
export * from "./Checkin.vue?vue&type=script&lang=js&"
import style0 from "./Checkin.vue?vue&type=style&index=0&id=388752a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388752a8",
  null
  
)

export default component.exports